import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './rootRoute';

/**
 * Public pages (IA §2 "Public": /share/:token, /tv/:token, /m/:token): a pathless layout under
 * the root, beside the signed-in app route — no session check, no `/api/me`, no app shell.
 * Modules hang such pages under it and list them in their `publicRoutes` (modules/types.ts);
 * the page brings its own chrome and asks only public endpoints (a capability token).
 */
export const publicRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'public',
});
